import * as moment from 'moment';
import { DateTimeConverter } from 'src/app/core/services/mapper/converters';
import { CodeEspece } from './enums/code-espece.enum';
export class Recolte {
    static jsonMap = {
        id: { key: 'idRecolte', optional: true },
        idEspece: { key: 'idEspece', optional: true },
        codeEspece: { key: 'codeEspece', optional: true, default: '' },
        idGroupeVarietal: { key: 'idGroupeVarietal', optional: true },
        codeGroupeVarietal: { key: 'codeGroupeVarietal', optional: true, default: '' },
        groupeVarietal: { key: 'groupeVarietal', optional: true, default: '' },
        groupeVarietalVarietes: { key: 'groupeVarietalVarietes', optional: true, default: '' },

        qteTotalePrecedente: { key: 'qteTotalePrecedente', optional: true },
        qteBioPrecedente: { key: 'qteBioPrecedente', optional: true },

        qteTotaleDernierePrevision: { key: 'qteTotaleDernierePrevision', optional: true },
        qteBioDernierePrevision: { key: 'qteBioDernierePrevision', optional: true },

        qteTotale: { key: 'qteTotale', optional: true },
        qteBio: { key: 'qteBio', optional: true },

        surfaceTotale: { key: 'surfaceTotale', optional: true },
        surfaceBio: { key: 'surfaceBio', optional: true },

        datePrevisionInitiale: { key: 'datePrevisionInitiale', converter: new DateTimeConverter(), optional: true },
        datePrevisionActuelle: { key: 'datePrevisionActuelle', converter: new DateTimeConverter(), optional: true },
        dateSaisieRecolte: { key: 'dateSaisieRecolte', converter: new DateTimeConverter(), optional: true },
        previsionInitialeTotale: { key: 'previsionInitialeTotale', optional: true },
        previsionInitialeBio: { key: 'previsionInitialeBio', optional: true }
    };

    id: number = undefined;
    public idEspece: number = null;
    public codeEspece: string = null;

    idGroupeVarietal: number = null;
    codeGroupeVarietal: string;
    groupeVarietal: string = null;
    groupeVarietalVarietes: string;

    qteTotalePrecedente: number = null;
    qteBioPrecedente: number = null;

    qteTotaleDernierePrevision: number = null;
    qteBioDernierePrevision: number = null;

    qteTotale: number = null;
    qteBio: number = null;

    surfaceTotale: number = null;
    surfaceBio: number = null;

    datePrevisionInitiale: moment.Moment;
    datePrevisionActuelle: moment.Moment;
    dateSaisieRecolte: moment.Moment;

    previsionInitialeTotale: number = null;
    previsionInitialeBio: number = null;

    public getRdtTotalPrecedent(): number {
        return this.surfaceTotale ? this.qteTotalePrecedente / this.surfaceTotale : undefined;
    }
    public getRdtBioPrecedent(): number {
        return this.surfaceBio ? this.qteBioPrecedente / this.surfaceBio : undefined;
    }

    getRdtInitialTotal(): number {
        return this.surfaceTotale ? this.previsionInitialeTotale / this.surfaceTotale : undefined;
    }

    public getRdtInitialBio(): number {
        return this.surfaceBio ? this.previsionInitialeBio / this.surfaceBio : undefined;
    }

    public getRdtTotalDernierePrevision(): number {
        return this.surfaceTotale ? this.qteTotaleDernierePrevision / this.surfaceTotale : undefined;
    }
    public getRdtBioDernierePrevision(): number {
        return this.surfaceBio ? this.qteBioDernierePrevision / this.surfaceBio : undefined;
    }

    public getRdtTotal(): number {
        return this.surfaceTotale ? this.qteTotale / this.surfaceTotale : undefined;
    }

    public getRdtTotalSuiviRecolte(declarationDefinitive: boolean): number {
        if (declarationDefinitive) {
            return this.surfaceTotale ? this.qteTotale / this.surfaceTotale : undefined;
        } else {
            return this.surfaceTotale ? this.qteTotaleDernierePrevision / this.surfaceTotale : undefined;
        }
    }

    public getQteTotaleSuiviRecolte(declarationDefinitive: boolean): number {
        return declarationDefinitive ? this.qteTotale : this.qteTotaleDernierePrevision;
    }

    public getRdtTotalSaisi(): number {
        return this.surfaceTotale ? this.qteTotale / this.surfaceTotale : undefined;
    }
    public getRdtBioSaisi(): number {
        return this.surfaceBio ? this.qteBio / this.surfaceBio : undefined;
    }

    public getNbJoursDepuisPrevision(): number {
        let nbJours: number;
        if (this.datePrevisionActuelle != null) {
            const dateNow = moment();
            nbJours = dateNow.diff(this.datePrevisionActuelle, 'days');
        }
        return nbJours;
    }

    isTotal = false;
    isAutre(): boolean {
        return ['autVarpomme', 'autVarpoir', 'autVarpoire'].indexOf(this.codeGroupeVarietal) > -1;
    }

    sorting(): string {
        const x = ''.concat(
            this.codeEspece === CodeEspece.POMME ? '0' : this.codeEspece === CodeEspece.POIRE ? '1' : '2',
            this.isTotal ? '1' : '0',
            this.isAutre() ? '1' : '0',
            this.groupeVarietal.toUpperCase()
        );
        return x;
    }
}
